import { Car, Truck, Motorcycle as Bike, Boat as Ship, Tractor, Crane as Construction, Bus, Package as Container, Lightning as Zap } from '@phosphor-icons/react';
import type { Icon as LucideIcon } from '@phosphor-icons/react';

export type VehicleType = 
  | 'car' 
  | 'truck' 
  | 'motorcycle' 
  | 'van' 
  | 'boat' 
  | 'agricultural' 
  | 'construction' 
  | 'trailer' 
  | 'atv';

export const vehicleIcons: Record<VehicleType, LucideIcon> = {
  car: Car,
  truck: Truck,
  motorcycle: Bike,
  van: Bus,
  boat: Ship,
  agricultural: Tractor,
  construction: Construction,
  trailer: Container,
  atv: Zap,
};

export const vehicleLabels: Record<VehicleType, string> = {
  car: 'Mașini',
  truck: 'Camioane',
  motorcycle: 'Motociclete',
  van: 'Autoutilitare',
  boat: 'Ambarcațiuni',
  agricultural: 'Utilaje Agricole',
  construction: 'Utilaje Construcții',
  trailer: 'Remorci',
  atv: 'ATV/UTV',
};

export const getVehicleIcon = (type: string): LucideIcon => {
  return vehicleIcons[type as VehicleType] || Car;
};

export const getVehicleLabel = (type: string): string => {
  return vehicleLabels[type as VehicleType] || 'Vehicul';
};
